import { render, staticRenderFns } from "./configDuty.vue?vue&type=template&id=35ad861e&"
import script from "./configDuty.vue?vue&type=script&lang=js&"
export * from "./configDuty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports